import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

import { UiIconsModule } from 'ui-icons';

import { UiPlatformStatusMarkerComponent } from './status-marker.component';

@NgModule({
  declarations: [UiPlatformStatusMarkerComponent],
  imports: [
    CommonModule,
    UiIconsModule,
    NzButtonModule,
    NzDropDownModule,
    TranslocoModule
  ],
  exports: [UiPlatformStatusMarkerComponent]
})
export class UiPlatformStatusMarkerModule {}
